
import { mergeStyleSets } from '@bingads-webui-react/fabric-control';

export const getStyles = () => ({
  teachingBubbleContent: {
    '& .ms-TeachingBubble-content': {
      '& .conversion-coupon-callout-card-coupon': {
        lineHeight: 2.5,
        fontWeight: 'bold',
        '& .helpbutton': {
          verticalAlign: 'baseline',
        },
      },
      '& .import-callout-card-coupon': {
        lineHeight: 2.5,
        fontWeight: 'bold',
        '& .helpbutton': {
          verticalAlign: 'baseline',
        },
      },
      '& .ms-TeachingBubble-subText': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      '& .ms-TeachingBubble-footer': {
        justifyContent: 'flex-start',
        '&:hover': {
          border: 'none',
        },
        '& .ms-Button': {
          marginLeft: 0,
          marginRight: 10,
          marginBottom: 10,
        },
        marginBottom: -10,
        '& .ms-Button--primary': {
          border: '1px solid rgb(255, 255, 255)',
          '&:hover': {
            border: '1px solid rgb(255, 255, 255)',
          },
        },
      },
    },
  },
  criticalInfo: {
    '& .addressLabel': {
      paddingLeft: 0,
    },
    '& .accountsLabel': {
      paddingLeft: 0,
    },
  },
  dialogFooter: {
    justifyContent: 'flex-start',
    display: 'flex',
  },
});

export const styles = mergeStyleSets({
  callout: {
    maxWidth: 364,
    border: 0,
    '& .ms-Callout-beak': {
      backgroundColor: 'rgb(0, 120, 212)',
    },
    '& .ms-Callout-beakCurtain': {
      backgroundColor: 'rgb(0, 120, 212)',
    },
    '& .ms-Callout-main': {
      padding: '20px',
      backgroundColor: 'rgb(0, 120, 212)',
      color: 'rgb(255, 255, 255)',
    },
    '& .conversion-coupon-callout-card-coupon': {
      fontWeight: 'bold',
      '& .helpbutton': {
        verticalAlign: 'baseline',
        color: 'rgb(255, 255, 255) !important',
      },
      marginBottom: 10,
    },
    '& .import-callout-card-coupon': {
      fontWeight: 'bold',
      '& .helpbutton': {
        verticalAlign: 'baseline',
        color: 'rgb(255, 255, 255) !important',
      },
      marginBottom: 10,
    },
  },
  title: {
    marginBottom: 14,
    marginRight: 12,
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    overflowWrap: 'break-word',
    fontSize: 20,
  },
  content: {
    marginBottom: 20,
    color: 'rgb(255, 255, 255)',
    overflowWrap: 'break-word',
    fontSize: 14,
    '& a:focus': {
      outline: '1px solid white',
    },
  },
  footer: {
    display: 'flex',
    flexWrap: 'wrap',

    '& .ms-StackItem': {
      marginRight: 10,
      maxWidth: '100%',
    },
  },
  footerText: {
    color: 'rgb(255, 255, 255)',
  },
  defaultBtn: {
    color: 'rgb(0, 120, 212)',
    maxWidth: '150px',

    '& .ms-Button-label': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '120px',
      paddingBottom: '2px',
    },

    '&:hover': {
      color: 'rgb(0, 120, 212)',
    },
  },
  primaryBtn: {
    border: '1px solid rgb(255, 255, 255)',
    borderRadius: 2,
    maxWidth: '150px',

    '& .ms-Button-label': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '120px',
      paddingBottom: '2px',
    },

    '&:hover': {
      border: '1px solid rgb(255, 255, 255)',
      backgroundColor: 'rgb(16, 110, 190)',
    },
  },
  closeBtn: {
    color: 'rgb(255, 255, 255) !important',
    backgroundColor: 'transparent',
    border: 'none',

    '&:hover': {
      color: 'rgb(255, 255, 255) !important',
      background: 'rgb(16, 110, 190)',
      border: 'none',
    },

    '&:focus::after': {
      outlineColor: 'white !important',
    },
  },
});
